import { MONTH_NAMES_ID, DAY_NAMES_ID } from "@/lib/calendar/dates";
import { gregorianToHijri, HIJRI_MONTHS } from "@/lib/calendar/hijri";

/**
 * Two-tile date header: Gregorian day + Hijri day.
 * Big number on top, label below — matches the user's mockup.
 */
export function DateHeaderTiles({ y, m, d }: { y: number; m: number; d: number }) {
  const hijri = gregorianToHijri(y, m, d);
  const dayName = DAY_NAMES_ID[new Date(y, m - 1, d).getDay()];
  return (
    <div className="mt-3 flex flex-wrap items-stretch gap-2">
      <div className="flex min-w-[110px] flex-col items-center justify-center rounded-lg bg-prayer/10 px-4 py-2 ring-1 ring-prayer/20">
        <span className="text-[10px] font-semibold uppercase tracking-wider text-prayer">{dayName}</span>
        <span className="font-display text-3xl leading-none text-prayer">{String(d).padStart(2, "0")}</span>
        <span className="mt-0.5 text-[11px] text-muted-foreground">{MONTH_NAMES_ID[m - 1]} {y}</span>
      </div>
      <div className="flex min-w-[140px] flex-col items-center justify-center rounded-lg border border-prayer/30 bg-card px-4 py-2">
        <span className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">Hijriah</span>
        <span className="font-display text-2xl leading-tight text-foreground">
          {hijri.day} {HIJRI_MONTHS[hijri.month - 1]}
        </span>
        <span className="mt-0.5 text-[11px] text-muted-foreground">{hijri.year} H</span>
      </div>
    </div>
  );
}
